import React, { useState, useEffect } from 'react';
import { Modal, Select } from "antd";
import { mixGetV1, mixPostV1, mixPutV1 } from "services/mixin";
import { message } from "antd";
import dayjs from "dayjs";

const PayoutContent = () => {
    // Dữ liệu tĩnh tạm thời
    // const userData = {
    //     affiliate_commission_total: 5000000,
    //     info: { wallet: 1200000 },
    //     bank: {
    //         number: '123456789',
    //         bank: 'Vietcombank',
    //         name: 'Nguyen Van A',
    //     },
    // };
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState<any>(null);

    const [bankInfo, setBankInfo] = useState('Bank Name: Ngân hàng Đông Á\nAccount Holder’s Full Name: 1235322\nBank Account Number: 21');
    const [showCashOutModal, setShowCashOutModal] = useState(false);
    const [showBankModal, setShowBankModal] = useState(false);
    const [bankForm, setBankForm] = useState({ name: '', number: '', bank: '' });
    const [catOutData, setCatOutData] = useState({ amount: '', note: '' });
    const [selectTime, setSelectTime] = useState(false);
    const [typeDateLabel, setTypeDateLabel] = useState('Tất cả thời gian');
    const [listData, setListData] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(10);


    // const listData = [
    //     { id: 1, amount: '1.500.000', status: 1, request_at: '30/06/2024 12:59', paid_at: '30/07/2024 12:59' },
    //     { id: 2, amount: '2.000.000', status: 2, request_at: '01/07/2024 10:30', paid_at: '30/07/2024 12:59' },
    //     { id: 3, amount: '3.000.000', status: 3, request_at: '02/07/2024 09:15', paid_at: '30/07/2024 12:59' },
    // ];
    const banks = [
        { bankId: 1, shortName: "VCB", vn_name: "Vietcombank" },
        { bankId: 2, shortName: "ACB", vn_name: "ACB" },
        { bankId: 3, shortName: "MB", vn_name: "MB Bank" },
    ];

    const totalPage = [1, 2, 3]; // tạm thời

    const currencyFormat = (value: number) => new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);

    const [visible, setVisible] = useState(false);
    const [dataBank, setDataBank] = useState({ name: "", number: "" });
    const [dropdownOpen, setDropdownOpen] = useState(false);

    // const saveBank = () => {
    //     console.log("Saved Bank Info:", dataBank, selectedBank);
    //     setVisible(false);
    // };
    const fetchCashOutList = async (page = 1) => {
        try {
            const res = await mixGetV1(
                `/api/v1/fe/customer/cash_outs?sort[]=id,desc&page=${page}&limit=${limit}&between[]=created_at,1888-12-21%2010:58:32,2025-11-13%2010:58:32&language=vi`
            );
            if (res?.status) {
                setListData(res.data?.items || []);
                setTotal(res.data?.total || 0);
            } else {
                message.error("Không thể tải danh sách rút tiền!");
            }
        } catch (err) {
            console.error(err);
            message.error("Lỗi khi gọi API cash_outs!");
        }
    };

    useEffect(() => {
        fetchCashOutList(page);
    }, [page]);

    // const saveBank = async () => {
    //     if (!bankForm.name || !bankForm.number || !selectedBank) {
    //         message.warning("Vui lòng điền đầy đủ thông tin ngân hàng!");
    //         return;
    //     }
    //     try {
    //         if (userData?.bank?.id) {
    //             // Cập nhật thông tin ngân hàng
    //             await mixPutV1(`/api/v1/fe/customer/bank/${userData.bank.id}`, {
    //                 name: bankForm.name,
    //                 number: bankForm.number,
    //                 bank: selectedBank,
    //             });
    //         } else {
    //             // Thêm mới ngân hàng
    //             await mixPostV1("/api/v1/fe/customer/bank", {
    //                 name: bankForm.name,
    //                 number: bankForm.number,
    //                 bank: selectedBank,
    //             });
    //         }
    //         setUserData((prev: any) => ({
    //             ...prev,
    //             bank: { ...bankForm, bank: selectedBank },
    //         }));
    //         message.success("Cập nhật thông tin ngân hàng thành công!");
    //         setShowBankModal(false);
    //     } catch (error: any) {
    //         console.error(error);
    //         if(error?.error === 'data_exist') {
    //             message.warning("Ngân hàng đã tồn tại, vui lòng cập nhật thay vì thêm mới!");
    //         } else {
    //             message.error("Lỗi khi lưu thông tin ngân hàng!");
    //         }
    //     }
    // };
    const saveBank = async () => {
        if (!bankForm.name || !bankForm.number || !selectedBank) {
            message.warning("Vui lòng điền đầy đủ thông tin!");
            return;
        }

        try {
            if (userData?.bank?.id) {
                // UPDATE
                await mixPutV1(`/api/v1/fe/customer/bank/${userData.bank.id}`, {
                    name: bankForm.name,
                    number: bankForm.number,
                    bank: selectedBank,
                });

                setUserData((prev) => ({
                    ...prev,
                    bank: {
                        id: prev.bank.id,
                        name: bankForm.name,
                        number: bankForm.number,
                        bank: selectedBank,
                    },
                }));
            }
            else {
                // CREATE
                const res = await mixPostV1("/api/v1/fe/customer/bank", {
                    name: bankForm.name,
                    number: bankForm.number,
                    bank: selectedBank,
                });

                setUserData((prev) => ({
                    ...prev,
                    bank: {
                        id: res.data.id,
                        name: bankForm.name,
                        number: bankForm.number,
                        bank: selectedBank,
                    },
                }));
            }

            message.success("Lưu thành công!");
            setShowBankModal(false);
        } catch (err) {
            message.error("Lỗi khi lưu ngân hàng!");
            console.log(err);
        }
    };


    const [selectedBank, setSelectedBank] = useState<string | null>(null);

    // Dữ liệu tĩnh
    const banksv2 = [
        { bankId: 1, shortName: "VCB", vn_name: "Vietcombank" },
        { bankId: 2, shortName: "ACB", vn_name: "Asia Commercial Bank" },
        { bankId: 3, shortName: "MB", vn_name: "Military Bank" },
        { bankId: 4, shortName: "VCB", vn_name: "Vietcombank" },
        { bankId: 5, shortName: "ACB", vn_name: "Asia Commercial Bank" },
        { bankId: 6, shortName: "MB", vn_name: "Military Bank" },

    ];

    const selectedBankText =
        banksv2.find((bank) => bank.vn_name === selectedBank)?.shortName || "";
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await mixGetV1("/api/v1/fe/customer/profile");
                if (res?.status && res?.data) {
                    setUserData(res.data);
                } else {
                    message.error("Không thể tải dữ liệu hồ sơ!");
                }
            } catch (error) {
                console.error(error);
                message.error("Lỗi khi tải dữ liệu hồ sơ!");
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);
    useEffect(() => {
        if (userData?.bank) {
            setBankInfo(
                `Bank Name: ${userData.bank.bank || ''}\n` +
                `Account Holder’s Full Name: ${userData.bank.name || ''}\n` +
                `Bank Account Number: ${userData.bank.number || ''}`
            );
        }
    }, [userData]);
    const handleCashOut = async () => {
        if (!catOutData.amount) {
            message.warning("Vui lòng nhập số tiền rút!");
            return;
        }
        try {
            const res = await mixPostV1("/api/v1/fe/customer/cash_out", {
                amount: catOutData.amount,
                note: catOutData.note,
            });
            if (res?.status) {
                message.success("Yêu cầu rút tiền thành công!");
                setShowCashOutModal(false);
                setUserData((prev: any) => ({
                    ...prev,
                    info: {
                        ...prev.info,
                        wallet: prev.info.wallet - Number(catOutData.amount)
                    }
                }));
                setCatOutData({ amount: '', note: '' });
            } else {
                message.error(res?.msg || "Rút tiền thất bại!");
            }
        } catch (error) {
            console.error(error);
            message.error("Lỗi khi thực hiện rút tiền!");
        }
    };



    return (
        <div className="payout-content">
            {/* Group 1 */}
            <div className="group">
                <div className="group-cols">
                    <div className="group-col">
                        <label className="group-label mb-16">Total commissions</label>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                value={currencyFormat(userData?.affiliate_commission_total)}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="separator" />
                    <div className="group-col">
                        <label className="group-label mb-16">Unpaid commission</label>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                value={currencyFormat(userData?.info?.wallet || 0)}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="separator" />
                    <div className="group-col">
                        <label className="group-label mb-16">Total payouts</label>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                value={currencyFormat((userData?.affiliate_commission_total || 0) - (userData?.info?.wallet || 0))}
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Group 2 */}
            <div className="group">
                {bankInfo ? (
                    <div className="group-cols">
                        <div className="group-col">
                            <div className="title-btn-edit">
                                <div className="left-content column-767">
                                    <label className="group-label">Payout information</label>
                                    <div className="status">Information required</div>
                                </div>
                                <div className="icon-edit" style={{ cursor: 'pointer' }} onClick={() => setShowBankModal(true)}>
                                    <svg
                                        width="25"
                                        height="24"
                                        viewBox="0 0 25 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M10.1387 4H7.29991C6.1643 4 5.59607 4 5.16233 4.21799C4.7808 4.40973 4.47082 4.71547 4.27642 5.0918C4.05542 5.51962 4.05542 6.08009 4.05542 7.2002V16.8002C4.05542 17.9203 4.05542 18.4801 4.27642 18.9079C4.47082 19.2842 4.7808 19.5905 5.16233 19.7822C5.59565 20 6.16319 20 7.29658 20H17.0357C18.1691 20 18.7358 20 19.1691 19.7822C19.5507 19.5905 19.8617 19.2839 20.0561 18.9076C20.2769 18.4802 20.2769 17.921 20.2769 16.8031V14M16.2215 5L10.1385 11V14H13.18L19.263 8M16.2215 5L19.263 2L22.3046 5L19.263 8M16.2215 5L19.263 8"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <div className="input-row">
                                <textarea className="input textarea" rows={3} readOnly value={bankInfo} />
                            </div>
                        </div>
                        <div className="separator" />
                        <div className="group-col">
                            <div className="title-btn-edit mb-8">
                                <div className="left-content">
                                    <label className="group-label">Receiving payment</label>
                                    <div className="icon-edit">
                                        <svg
                                            width="25"
                                            height="24"
                                            viewBox="0 0 25 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M12.2422 11V16M12.2422 21C7.20288 21 3.11768 16.9706 3.11768 12C3.11768 7.02944 7.20288 3 12.2422 3C17.2816 3 21.3668 7.02944 21.3668 12C21.3668 16.9706 17.2816 21 12.2422 21ZM12.2927 8V8.1L12.1917 8.1002V8H12.2927Z"
                                                stroke="#ADB1B3"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <p className="group-desc mb-32">
                                Reminder: Bidai can only process payments if your unpaid commission exceeds VND 300,000.
                            </p>
                            <div className="action-btn d-flex-inline" onClick={() => setShowCashOutModal(true)}>
                                Cash out
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="notRegis">
                        <div className="left-content column-767 wrap-title">
                            <label className="group-label">Thông tin thanh toán</label>
                            <div className="status">Cần thông tin</div>
                        </div>
                        <div className="action-btn d-flex-inline cts-show-regis-bank" onClick={() => setVisible(true)}>
                            Khai báo thông tin ngân hàng
                        </div>
                    </div>

                )}
            </div>

            <Modal
                open={visible}
                centered
                footer={null}
                closable={false}
                onCancel={() => setVisible(false)}
                className="rs-modal modal-472 bg-1E1F20"
            >
                <div className="fz-16">
                    <div className="color-white fw-700 title-32 text-center mb-2">
                        Thông tin thanh toán
                    </div>

                    <input
                        value={dataBank.name}
                        onChange={(e) =>
                            setDataBank((prev) => ({ ...prev, name: e.target.value }))
                        }
                        className="input-readonly form-control w-100 border-1 mt-2"
                        placeholder="Nhập họ tên đầy đủ trên thẻ"
                    />

                    <div className="rs-dropdown cts-dropdown w-100 mt-2 mb-2 height-48px">
                        {/* <Select
                            className="rs-dropdown cts-dropdown"
                            placeholder="Tên ngân hàng"
                            value={selectedBank || undefined}
                            onChange={(value) => setSelectedBank(value)}
                            style={{ width: "100%" }}
                            dropdownClassName="w-100"
                            optionLabelProp="label"
                            suffixIcon={
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M19 9L12 16L5 9"
                                        stroke="#ADB1B3"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            }
                        >
                            {banksv2.map((bank) => (
                                <Select.Option
                                    key={bank.bankId}
                                    value={bank.vn_name}
                                    label={bank.shortName}
                                >
                                    {bank.shortName}
                                </Select.Option>
                            ))}
                        </Select> */}
                        <input
                            value={selectedBank || ""}
                            onChange={(e) => setSelectedBank(e.target.value)}
                            className="input-readonly form-control w-100 border-1 mt-2"
                            placeholder="Nhập tên ngân hàng"
                        />

                    </div>

                    <input
                        value={dataBank.number}
                        onChange={(e) =>
                            setDataBank((prev) => ({ ...prev, number: e.target.value }))
                        }
                        className="input-readonly form-control w-100 border-1"
                        placeholder="Bank account number"
                    />

                    <button
                        className="button t-button-primary cts-savebank"
                        style={{ "--btn-radius": "8px" } as React.CSSProperties}
                        onClick={saveBank}
                    >
                        Lưu
                    </button>
                </div>
            </Modal>

            <Modal
                open={showCashOutModal}
                centered
                footer={null}
                closable={false}
                closable={true}
                onCancel={() => setShowCashOutModal(false)}
                className="rs-modal modal-472 bg-1E1F20"
            >
                <div className="modal-overlay">
                    <div className="modal-content fz-16">
                        <h3 className="color-white fw-700 title-32 text-center mb-20">Rút tiền</h3>
                        <div className="input-readonly input-readonly--black3 mt-10">
                            {userData?.bank && (
                                <div className="d-flex flex-column gap-20">
                                    <div className="d-flex justify-content-between gap-10">
                                        <span>Vào tài khoản ngân hàng</span>
                                        <span className="text-right">{userData?.bank?.number}</span>
                                    </div>
                                    <div className="d-flex justify-content-between gap-10">
                                        <span>Tên ngân hàng</span>
                                        <span className="text-right">{userData?.bank?.bank}</span>
                                    </div>
                                    <div className="d-flex justify-content-between gap-10">
                                        <span>Họ tên</span>
                                        <span className="text-right">{userData?.bank?.name}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <input
                            className="input-readonly form-control w-100 mt-6 border-1"
                            placeholder="Nhập số tiền rút"
                            value={catOutData.amount}
                            onChange={(e) => setCatOutData({ ...catOutData, amount: e.target.value })}
                        />
                        <input
                            className="input-readonly form-control w-100 border-1 mt-2"
                            placeholder="Thêm ghi chú (tùy chọn)"
                            value={catOutData.note}
                            onChange={(e) => setCatOutData({ ...catOutData, note: e.target.value })}
                        />
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                            <button className="button t-button-primary cts-cashout" onClick={handleCashOut}>
                                Xác nhận
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                open={showBankModal}
                centered
                footer={null}
                closable={false}
                closable={true}
                onCancel={() => setShowBankModal(false)}
                className="rs-modal modal-472 bg-1E1F20"
            >
                <div className="fz-16">
                    <div className="color-white fw-700 title-32 text-center mb-20">
                        Payout history
                    </div>

                    <input
                        value={bankForm.name}
                        onChange={(e) =>
                            setBankForm((prev) => ({ ...prev, name: e.target.value }))
                        }
                        className="input-readonly form-control w-100 border-1 mb-2"
                        placeholder="Nhập họ tên đầy đủ trên thẻ"
                    />

                    <div className="rs-dropdown cts-dropdown w-100 mb-2">
                        {/* <Select
                            className="rs-dropdown cts-dropdown"
                            placeholder="Tên ngân hàng"
                            value={selectedBank || undefined}
                            onChange={(value) => setSelectedBank(value)}
                            style={{ width: "100%" }}
                            dropdownClassName="w-100"
                            optionLabelProp="label" 
                        >
                            {banks.map((bank) => (
                                <Select.Option
                                    key={bank.bankId}
                                    value={bank.vn_name}
                                    label={bank.shortName}
                                >
                                    {bank.shortName}
                                </Select.Option>
                            ))}
                        </Select> */}
                        <input
                            value={selectedBank || ""}
                            onChange={(e) => setSelectedBank(e.target.value)}
                            className="input-readonly form-control w-100 border-1 mb-2"
                            placeholder="Nhập tên ngân hàng"
                        />

                    </div>

                    <input
                        value={bankForm.number}
                        onChange={(e) =>
                            setBankForm((prev) => ({ ...prev, number: e.target.value }))
                        }
                        className="input-readonly form-control w-100 border-1 mb-4"
                        placeholder="Số tài khoản"
                    />

                    <button
                        className="button t-button-primary cts-savebank"
                        style={{ "--btn-radius": "8px" } as React.CSSProperties}
                        onClick={saveBank}
                    >
                        Lưu
                    </button>
                </div>
            </Modal>


            {/* Group 3 - Table */}
            <div className="group">
                <div className="table-wrapper">
                    <table className="referrals-table one-column-25">
                        <thead>
                            <tr>
                                <th className="text-left">Amount</th>
                                <th className="text-center">Status</th>
                                <th>Requested at</th>
                                <th className="text-right">Paid at</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listData.map((item) => (
                                <tr key={item.id}>
                                    <td className="text-left">{item.amount}</td>
                                    <td className="text-center">
                                        <div className={`status status-${item.status}`}>
                                            {item.status === 1 ? 'Thành công' : item.status === 0 ? 'Đang chờ' : 'Đang xử lý'}
                                        </div>
                                    </td>
                                    <td className="text-center">{item.created_at ? dayjs(item.created_at).format("DD/MM/YYYY") : "-"}</td>
                                    <td className="text-right">{item.updated_at ? dayjs(item.updated_at).format("DD/MM/YYYY") : "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <div className="showing">Showing 3 of 3</div>
                <div className="pages">
                    <button className="nav-btn">{"<"}</button>
                    {totalPage.map((_, index) => (
                        <button key={index} className="page-btn active">
                            {index + 1}
                        </button>
                    ))}
                    <button className="nav-btn">{">"}</button>
                </div>
            </div>
        </div>
    );
};

export default PayoutContent;
